<template>
  <div class="news-container">
    <div class="news-banner">
      <img src="http://xgame-icv.zbmec.com:9000/qf-test-management-provincial/news/news_bg.png"
           alt="banner"
           class="banner-image">
    </div>
    <div class="content-wrapper">
      <a-tabs 
        v-model:activeKey="activeTab" 
        animated="false"
        tabBarGutter="0"
        destroyInactiveTabPane
        @change="handleTabChange"
      >
        <a-tab-pane key="1" tab="通知公告">
          <div class="tab-content">
            <div class="info-list">
              <a-list
                :data-source="notices"
                class="notice-list"
              >
                <template #renderItem="{ item }">
                  <a-list-item class="info-item">
                    <div class="info-cover">
                      <a :href="item.linkUrl" target="_blank">
                        <img :src="item.coverImg" alt="cover" />
                      </a>
                    </div>
                    <div class="info-content">
                      <a :href="item.linkUrl" class="info-title" target="_blank">{{ item.title }}</a>
                      <div class="info-date">{{ formatDate(item.publishDate) }}</div>
                    </div>
                  </a-list-item>
                </template>
              </a-list>
              <!-- 独立的分页组件 -->
              <div class="pagination-container">
                <a-pagination
                  v-model:current="pagination.notices.current"
                  v-model:pageSize="pagination.notices.pageSize"
                  :total="totals.notices || 0"
                  :showSizeChanger="true"
                  :pageSizeOptions="['5', '10', '20', '50']"
                  :showTotal="(total) => `共 ${total} 条数据`"
                  @change="(page) => handlePaginationChange('notices')"
                  @showSizeChange="(current, size) => {
                    pagination.notices.pageSize = size;
                    handlePaginationChange('notices');
                  }"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="活动动态">
          <div class="tab-content">
            <div class="info-list">
              <a-list
                :data-source="activities"
                class="activity-list"
              >
                <template #renderItem="{ item }">
                  <a-list-item class="info-item">
                    <div class="info-cover">
                      <a :href="item.linkUrl" target="_blank">
                        <img :src="item.coverImg" alt="cover" />
                      </a>
                    </div>
                    <div class="info-content">
                      <a :href="item.linkUrl" class="info-title" target="_blank">{{ item.title }}</a>
                      <div class="info-date">{{ formatDate(item.publishDate) }}</div>
                    </div>
                  </a-list-item>
                </template>
              </a-list>
              <!-- 独立的分页组件 -->
              <div class="pagination-container">
                <a-pagination
                  v-model:current="pagination.activities.current"
                  v-model:pageSize="pagination.activities.pageSize"
                  :total="totals.activities || 0"
                  :showSizeChanger="true"
                  :pageSizeOptions="['5', '10', '20', '50']"
                  :showTotal="(total) => `共 ${total} 条数据`"
                  @change="(page) => handlePaginationChange('activities')"
                  @showSizeChange="(current, size) => {
                    pagination.activities.pageSize = size;
                    handlePaginationChange('activities');
                  }"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- 新增政策法规tab -->
        <a-tab-pane key="3" tab="政策法规">
          <div class="tab-content">
            <div class="info-list">
              <a-list
                :data-source="policies"
                class="policy-list"
              >
                <template #renderItem="{ item }">
                  <a-list-item class="info-item">
                    <div class="info-cover">
                      <a :href="item.linkUrl" target="_blank">
                        <img :src="item.coverImg" alt="cover" />
                      </a>
                    </div>
                    <div class="info-content">
                      <a :href="item.linkUrl" class="info-title" target="_blank">{{ item.title }}</a>
                      <div class="info-date">{{ formatDate(item.publishDate) }}</div>
                    </div>
                  </a-list-item>
                </template>
              </a-list>
              <!-- 独立的分页组件 -->
              <div class="pagination-container">
                <a-pagination
                  v-model:current="pagination.policies.current"
                  v-model:pageSize="pagination.policies.pageSize"
                  :total="totals.policies || 0"
                  :showSizeChanger="true"
                  :pageSizeOptions="['5', '10', '20', '50']"
                  :showTotal="(total) => `共 ${total} 条数据`"
                  @change="(page) => handlePaginationChange('policies')"
                  @showSizeChange="(current, size) => {
                    pagination.policies.pageSize = size;
                    handlePaginationChange('policies');
                  }"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- 新增产业报告tab -->
        <a-tab-pane key="4" tab="产业报告">
          <div class="tab-content">
            <div class="info-list">
              <a-list
                :data-source="reports"
                class="report-list"
              >
                <template #renderItem="{ item }">
                  <a-list-item class="info-item">
                    <div class="info-cover">
                      <a :href="item.linkUrl" target="_blank">
                        <img :src="item.coverImg" alt="cover" />
                      </a>
                    </div>
                    <div class="info-content">
                      <a :href="item.linkUrl" class="info-title" target="_blank">{{ item.title }}</a>
                      <div class="info-date">{{ formatDate(item.publishDate) }}</div>
                    </div>
                  </a-list-item>
                </template>
              </a-list>
              <!-- 独立的分页组件 -->
              <div class="pagination-container">
                <a-pagination
                  v-model:current="pagination.reports.current"
                  v-model:pageSize="pagination.reports.pageSize"
                  :total="totals.reports || 0"
                  :showSizeChanger="true"
                  :pageSizeOptions="['5', '10', '20', '50']"
                  :showTotal="(total) => `共 ${total} 条数据`"
                  @change="(page) => handlePaginationChange('reports')"
                  @showSizeChange="(current, size) => {
                    pagination.reports.pageSize = size;
                    handlePaginationChange('reports');
                  }"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, computed } from 'vue';
import Footer from '@/components/GlobalFooter/footer.vue';
import { getPagesByCondition } from '@/api/news';

// 初始化数据列表
const notices = ref([]);
const activities = ref([]);
const policies = ref([]);
const reports = ref([]);

// 数据总数
const totals = reactive({
  notices: 0,
  activities: 0,
  policies: 0,
  reports: 0
});

// 分页状态管理
const pagination = reactive({
  notices: { current: 1, pageSize: 10 },
  activities: { current: 1, pageSize: 10 },
  policies: { current: 1, pageSize: 10 },
  reports: { current: 1, pageSize: 10 }
});

// 切换tab时触发
const activeTab = ref('1');

// 格式化日期为x年x月x日
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}年${month}月${day}日`;
};

// tab切换时触发的函数
const handleTabChange = (tabKey) => {
};

// 获取数据的通用函数
const fetchData = (type, dataList, totalKey) => {
  const data = {
    pageIndex: pagination[type].current,
    pageSize: pagination[type].pageSize,
    conditionMap: {
      type: getTypeCode(type),
      status: '1'
    }
  };
  
  getPagesByCondition(data).then((res) => {
    if (res.code === 200) {
      dataList.value = res.data.records || [];
      totals[totalKey] = res.data.total;
    }
  });
};

const getTypeCode = (type) => {
  const typeMap = {
    notices: '1',
    activities: '2',
    policies: '3',
    reports: '4'
  };
  return typeMap[type] || '1';
};

// 通知公告数据获取
const fetchNotices = () => {
  fetchData('notices', notices, 'notices');
};

// 活动动态数据获取
const fetchActivities = () => {
  fetchData('activities', activities, 'activities');
};

// 政策法规数据获取
const fetchPolicies = () => {
  fetchData('policies', policies, 'policies');
};

// 产业报告数据获取
const fetchReports = () => {
  fetchData('reports', reports, 'reports');
};

// 分页变化事件处理
const handlePaginationChange = (type) => {
  switch (type) {
    case 'notices':
      fetchNotices();
      break;
    case 'activities':
      fetchActivities();
      break;
    case 'policies':
      fetchPolicies();
      break;
    case 'reports':
      fetchReports();
      break;
    default:
      break;
  }
};

// 组件挂载时获取所有tab数据
onMounted(() => {
  fetchNotices();
  fetchActivities();
  fetchPolicies();
  fetchReports();
});
</script>

<style scoped lang="less">
.news-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: #fff;
}

.news-banner {
  width: 100%;
  height: 300px;
  overflow: hidden;
  margin-bottom: 20px;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.content-wrapper {
  padding: 0 300px;
  margin-bottom: 40px;
  flex: 1;
}

:deep(.ant-tabs-tab) {
  margin: 0 20px !important;
  padding: 12px 32px !important;
  font-size: 18px;
  font-weight: 500;
  position: relative;
  transition: none;
}

:deep(.ant-tabs-nav) {
  display: flex;
  justify-content: center;
  width: 100%;
}

:deep(.ant-tabs-tab-active) {
  font-weight: 600;
  color: #1890ff !important;
  border: 2px solid #1890ff;
  border-radius: 24px;
  background-color: transparent;
  padding: 10px 30px !important;
}

:deep(.ant-tabs-tab-active::before) {
  display: none;
}

:deep(.ant-tabs-ink-bar) {
  display: none;
}

:deep(.ant-tabs-tab:hover) {
  color: #1890ff !important;
}

:deep(.ant-tabs-content) {
  height: auto;
  overflow: hidden;
}

:deep(.ant-tabs-tabpane) {
  transition: none !important;
  animation: none !important;
}

:deep(.ant-tabs-tabpane-active) {
  transition: none !important;
  animation: none !important;
}

.tab-content {
  padding: 20px 0;
}

.info-list {
  padding: 0 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  gap: 16px;
}

.info-cover {
  width: 120px;
  height: 80px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.05);
  }
}

.info-content {
  flex: 1;
  min-width: 0;
}

.info-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #1890ff;
    text-decoration: underline;
  }
}

.info-date {
  font-size: 14px;
  color: #999;
  white-space: nowrap;
}

// 独立的分页组件样式
.pagination-container {
  margin-top: 20px;
  text-align: right;
  padding: 0 20px;
}
</style>